import OkC from "shared/util/OkcApi";

const getFilters = (userid) => {
	return OkC.get(`/profile/${userid}/answer_filters`, {
		cache: false,
	});
};

const getQuestions = (userid, params = {}) => {
	return OkC.get(`/profile/${userid}/answers`, {
		// ie11 was caching the result of this query between requests since there
		// are no query params that change. passing `cache: false` tells jquery to
		// not use the browser cache for this ajax request.
		cache: false,
		data: params,
	});
};

const getQuestion = (userid, qid) => {
	return OkC.get(`/profile/${userid}/answers`, {
		data: {
			qid,
		},
	});
};

const getNextQuestion = () => {
	return OkC.get("/questions/next", {
		// ie11 was caching the result of this query between requests since there
		// are no query params that change. passing `cache: false` tells jquery to
		// not use the browser cache for this ajax request.
		cache: false,
		data: {
			questions2017Format: true,
		},
	});
};

const skipQuestion = (qid) => {
	return OkC.post(`/questions/${qid}`, {
		data: {
			skip: true,
			source: "profile_questions",
		},
	});
};

const getUserInfo = (userid) => {
	return OkC.get(`profile/${userid}/fields`, {
		data: {
			fields: "thumbs.limit(1),likes,userinfo,percentages,question_summary",
		},
	});
};

export default {
	getFilters,
	getQuestions,
	getQuestion,
	getNextQuestion,
	skipQuestion,
	getUserInfo,
};



// WEBPACK FOOTER //
// ./src/apps/profile_questions/util/web.js